import CssBaseline from '@mui/material/CssBaseline';
import Stack from '@mui/material/Stack';
import AppTheme from '@theme/theme';
import { type ReactNode } from 'react';
import Content from './Content';

/**
 * The signed-out shell: the product pitch on one side, a single card on the other.
 *
 * Extracted from the sign-in page so first-run setup looks like the same product rather than a
 * bare form. A server that has never been set up is the first thing a customer sees of it.
 */
const AuthLayout = ({ children }: { children: ReactNode }) => {
  return (
    <AppTheme>
      <CssBaseline enableColorScheme />
      <Stack direction='column' component='main' sx={outerStackStyles}>
        <Stack direction={{ xs: 'column-reverse', md: 'row' }} sx={innerStackStyles}>
          <Stack direction={{ xs: 'column-reverse', md: 'row' }} sx={columnsStyles}>
            <Content />
            {children}
          </Stack>
        </Stack>
      </Stack>
    </AppTheme>
  );
};

const outerStackStyles = {
  justifyContent: 'center',
  height: 'calc((1 - var(--template-frame-height, 0)) * 100%)',
  marginTop: 'max(40px - var(--template-frame-height, 0px), 0px)',
  minHeight: '100%',
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    zIndex: 0,
    inset: 0,
    background: 'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
    backgroundRepeat: 'no-repeat',
  },
};

const innerStackStyles = {
  justifyContent: 'center',
  gap: { xs: 6, sm: 12 },
  p: 2,
  mx: 'auto',
  zIndex: 2,
};

const columnsStyles = {
  justifyContent: 'center',
  gap: { xs: 6, sm: 12 },
  p: { xs: 2, sm: 4 },
  m: 'auto',
};

export default AuthLayout;
